import React, { useState, useEffect } from "react";

const CrifScoreReportModal = ({
  isOpen,
  onClose,
  Equifaxv2Report,
  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
  isPdf,
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
   // console.log("crif v1", Equifaxv2Report);
  }, [Equifaxv2Report, Equifaxv2Error]);

  if (!isOpen) return null;

  const printDiv = () => {
    setIsPrinting(true);
    const printWindow = window.open("", "", "height=700,width=1000");
    const printContents =
      document.getElementById("invoicedata")?.innerHTML || "";

    printWindow.document.write("<html><head><title>Crif Score Report</title>");
    printWindow.document.write(
      '<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">',
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      setIsPrinting(false);
    }, 100);
  };

  // For success response, Equifaxv2Report should be the API JSON you pasted:
  // { status: {...}, message: "...", data: { report_data: {...} } }
  const modalData = isPdf
    ? Equifaxv2Report?.report_data?.crifData
    : Equifaxv2Report?.data?.credit_report?.crifData ||
      Equifaxv2Report?.data?.report_data?.crifData ||
      Equifaxv2Report?.data?.report_data?.['REPORT-DATA'] ||
      Equifaxv2Report?.credit_report?.crifData ||
      {};
  const modalDataError = Equifaxv2Error || null;

  const formatLabel = (key) =>
    key
      .replace(/[-_]/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const splitIntoColumns = (obj, columns = 3) => {
    const entries = Object.entries(obj || {});
    const result = Array.from({ length: columns }, () => []);
    entries.forEach((item, index) => {
      result[index % columns].push(item);
    });
    return result;
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div
        className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]"
        id="invoicedata"
      >
        <div className="a4-page">
          {displayMessageBlock &&
            (() => {
              const message =
                Equifaxv2Error?.error?.credit_report_message?.message ||
                Equifaxv2Error?.message ||
                Equifaxv2Report?.status?.message ||
                reportMessage ||
                "";

              const code =
                Equifaxv2Error?.error?.credit_report_message?.message_code ||
                Equifaxv2Error?.message_code ||
                Equifaxv2Report?.status?.code ||
                reportCode ||
                "";

              const isSuccess = message?.toLowerCase().includes("success");

              if (isSuccess) return null;

              const formatText = (text) =>
                text
                  ?.replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase());

              return (
                <>
                  {(message?.length > 0 || code?.length > 0) && (
                    <div className="flex flex-col items-center justify-center my-5">
                      <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                        <p className="text-center text-black font-bold">
                          Error:{" "}
                          <span className="font-normal">
                            {formatText(message)}
                          </span>
                        </p>
                        <p className="text-center text-black font-bold mt-1">
                          Code:{" "}
                          <span className="font-normal">
                            {formatText(code)}
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              );
            })()}

          {/* Header Section */}
          <div className="grid grid-cols-12 items-center gap-2 border-b pb-1 mt-1">
            {(() => {
              const formatKey = (key) =>
                key
                  .replace(/-/g, " ")
                  .replace(/_/g, " ")
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase(),
                  )
                  .join(" ");

              const headerData = modalData?.HEADER || {};
              const nameVariations =
                modalData?.["PERSONAL-INFO-VARIATION"]?.["NAME-VARIATIONS"]
                  ?.VARIATION || [];

              const latestName = Array.isArray(nameVariations)
                ? nameVariations[nameVariations.length - 1]?.VALUE
                : nameVariations?.VALUE ||
                  (modalDataError?.data?.first_name &&
                  modalDataError?.data?.last_name
                    ? `${modalDataError.data.first_name} ${modalDataError.data.last_name}`
                    : modalDataError?.data?.first_name ||
                      modalDataError?.first_name ||
                      "N/A");

              return (
                <>
                  <div className="col-span-12 sm:col-span-3 flex justify-center sm:justify-start">
                    <img
                      src="https://imgs.search.brave.com/F-FGsx3dw-ufK7fWVZmHd93EObunBV0adl6hfaiK9Zs/rs:fit:0:180:1:0/g:ce/aHR0cHM6Ly9kMjh3/dThvNml0djg5dC5j/bG91ZGZyb250Lm5l/dC9pbWFnZXMvQ1JJ/RmhpZ2htYXJrcG5n/LTE1NzQ4NDY5NTk0/NjgucG5n"
                      className="w-12 sm:w-28 md:w-28"
                      alt="Logo"
                    />
                  </div>

                  <div className="col-span-12 sm:col-span-6 text-center">
                    <h4 className="text-base sm:text-md md:text-md font-semibold">
                      Consumer Credit Report
                    </h4>
                    <p className="text-xs sm:text-xs mt-1">
                      <span className="font-semibold">For:</span>{" "}
                      <span className="font-bold">{latestName}</span>
                    </p>
                  </div>

                  <div className="col-span-12 sm:col-span-3 text-center sm:text-right text-xs sm:text-[10px]">
                    {Object.entries(headerData).map(([key, value]) => {
                      if (!value || key === "STATUS" || key === "inquiryId_")
                        return null;
                      return (
                        <p key={key}>
                          <span className="font-bold text-blue-600">
                            {formatKey(key)}:
                          </span>{" "}
                          <span className="font-semibold">{value}</span>
                        </p>
                      );
                    })}
                  </div>
                </>
              );
            })()}
          </div>

          {/* Personal Details */}
          <div className="flex justify-center mt-2">
            <p className="font-bold text-black text-sm">Personal Details</p>
          </div>

          <div className="border border-blue-500 p-2 rounded-md">
            {(() => {
              const formatKey = (key) =>
                key
                  .replace(/-/g, " ")
                  .replace(/_/g, " ")
                  .replace(/VARIATIONS?/gi, "")
                  .split(" ")
                  .filter(Boolean)
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase(),
                  )
                  .join(" ");

              const personalInfo = modalData?.["PERSONAL-INFO-VARIATION"] || {};
              const personalDetails = {};

              Object.entries(personalInfo).forEach(([key, variationData]) => {
                if (!variationData || typeof variationData !== "object") return;
                const variations = variationData.VARIATION;
                if (!variations) return;

                if (Array.isArray(variations)) {
                  if (variations.length > 0) {
                    const fieldName = formatKey(key);

                    if (key.includes("NAME") || key.includes("DOB")) {
                      personalDetails[fieldName] =
                        variations[variations.length - 1]?.VALUE;
                    } else if (
                      key.includes("PHONE") ||
                      key.includes("UID") ||
                      key.includes("RATION")
                    ) {
                      personalDetails[fieldName] = variations
                        .map((v) => v.VALUE)
                        .join(", ");
                    } else {
                      personalDetails[fieldName] = variations[0]?.VALUE;
                    }

                    if (variations[0]?.["REPORTED-DATE"]) {
                      personalDetails[`${fieldName} Reported Date`] =
                        variations[variations.length - 1]?.["REPORTED-DATE"];
                    }
                  }
                } else {
                  const fieldName = formatKey(key);
                  personalDetails[fieldName] = variations.VALUE;
                  if (variations["REPORTED-DATE"]) {
                    personalDetails[`${fieldName} Reported Date`] =
                      variations["REPORTED-DATE"];
                  }
                }
              });

              const dobKey = Object.keys(personalDetails).find((key) =>
                key.toLowerCase().includes("birth"),
              );
              if (dobKey && personalDetails[dobKey]) {
                const dobValue = personalDetails[dobKey];
                const dobParts = dobValue.split("-");
                if (dobParts.length === 3) {
                  const birthYear = parseInt(dobParts[2], 10);
                  const currentYear = new Date().getFullYear();
                  personalDetails["Age"] = currentYear - birthYear;
                }
              }

              const gender =
                modalDataError?.data?.gender || modalDataError?.gender;
              if (gender) {
                personalDetails["Gender"] = gender;
              }

              const displayDetails = Object.entries(personalDetails).filter(
                ([key]) => !key.toLowerCase().includes("reported date"),
              );

              if (displayDetails.length === 0) {
                return (
                  <p className="text-center text-gray-500 py-4">
                    No personal details available
                  </p>
                );
              }

              return (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-xs">
                  {displayDetails.map(([key, value]) => (
                    <div key={key}>
                      <p>
                        <i className="font-semibold">{key}:</i>
                        <span className="ml-1">{value || "N/A"}</span>
                      </p>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>

          <hr className="my-2" />

          {/* Address & Other Variations */}
          {(() => {
            const formatKey = (key) =>
              key
                .replace(/-/g, " ")
                .replace(/_/g, " ")
                .replace(/VARIATIONS?/gi, "")
                .split(" ")
                .filter(Boolean)
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
                )
                .join(" ");

            const personalInfo = modalData?.["PERSONAL-INFO-VARIATION"] || {};

            const variationSections = Object.entries(personalInfo).filter(
              ([, data]) => data && typeof data === "object" && data.VARIATION,
            );

            if (variationSections.length === 0) return null;

            return variationSections.map(([sectionKey, sectionData]) => {
              const variations = sectionData.VARIATION;
              if (!variations) return null;

              const normalizedVariations = Array.isArray(variations)
                ? variations
                : [variations];
              if (normalizedVariations.length === 0) return null;

              const allKeys = new Set();
              normalizedVariations.forEach((variation) => {
                if (variation && typeof variation === "object") {
                  Object.keys(variation).forEach((key) => allKeys.add(key));
                }
              });

              const displayKeys = Array.from(allKeys);

              return (
                <div key={sectionKey} className="mb-3">
                  <div className="bg-blue-200 md:text-black text-black p-1 border rounded rounded-tl-xl rounded-tr-xl text-sm font-semibold">
                    {formatKey(sectionKey)}
                  </div>

                  <table className="min-w-full table-auto border border-black text-left text-sm">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="border border-black px-1 py-0">#</th>
                        {displayKeys.map((key) => (
                          <th
                            key={key}
                            className="border border-black px-1 py-0"
                          >
                            {formatKey(key)}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="text-xs">
                      {normalizedVariations.map((variation, index) => (
                        <tr key={index}>
                          <td className="border border-black px-1 py-0 font-bold text-center">
                            {index + 1}
                          </td>
                          {displayKeys.map((key) => (
                            <td
                              key={key}
                              className="border border-black px-1 py-0"
                            >
                              {variation[key] || "N/A"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            });
          })()}

          {/* Credit Score */}
          <div className="bg-blue-300 md:text-black p-2 text-black mt-1 rounded-tl-md rounded-tr-md text-sm font-semibold">
            Credit Score
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border border-black text-left text-sm">
              {(() => {
                const scoresData = modalData?.SCORES?.SCORE;

                if (!scoresData) {
                  return (
                    <tbody>
                      <tr>
                        <td
                          colSpan="3"
                          className="border border-black px-4 py-8 text-center text-gray-500"
                        >
                          No score details available
                        </td>
                      </tr>
                    </tbody>
                  );
                }

                const scoresArray = Array.isArray(scoresData)
                  ? scoresData
                  : [scoresData];

                if (scoresArray.length === 0) {
                  return (
                    <tbody>
                      <tr>
                        <td
                          colSpan="3"
                          className="border border-black px-4 py-8 text-center text-gray-500"
                        >
                          No score details available
                        </td>
                      </tr>
                    </tbody>
                  );
                }

                const formatKey = (key) =>
                  key
                    .replace(/-/g, " ")
                    .replace(/_/g, " ")
                    .split(" ")
                    .map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase(),
                    )
                    .join(" ");

                return (
                  <>
                    <thead className="bg-gray-200">
                      <tr className="text-left text-xs font-semibold">
                        <th className="border border-black px-3 py-2 w-1/4">
                          Score Type
                        </th>
                        <th className="border border-black px-3 py-2 w-1/2">
                          Factors
                        </th>
                        <th className="border border-black px-3 py-2 w-1/4 text-center">
                          Score Value
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-xs">
                      {scoresArray.map((score, idx) => {
                        if (!score || typeof score !== "object") return null;

                        const keys = Object.keys(score);

                        const scoreTypeKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("type") ||
                            lower.includes("name") ||
                            lower.includes("bureau")
                          );
                        });
                        const scoreType = scoreTypeKey
                          ? score[scoreTypeKey]
                          : "Credit Score";

                        const factorsKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("factor") ||
                            lower.includes("element") ||
                            lower.includes("reason")
                          );
                        });
                        const factorsValue = factorsKey
                          ? score[factorsKey]
                          : "";
                        const factors = factorsValue
                          ? String(factorsValue)
                              .split("|")
                              .filter((f) => f && f.trim())
                          : [];

                        const scoreValueKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("value") ||
                            (lower.includes("score") &&
                              !lower.includes("type") &&
                              !lower.includes("factor"))
                          );
                        });
                        const scoreValue = scoreValueKey
                          ? score[scoreValueKey]
                          : "N/A";

                        return (
                          <tr key={idx} className="hover:bg-gray-50">
                            <td className="border border-black px-3 py-3 align-top">
                              <div>
                                <span className="font-semibold text-blue-700 block">
                                  {scoreType || "N/A"}
                                </span>
                                {scoreTypeKey && (
                                  <span className="text-[10px] text-gray-500 mt-1 block">
                                    ({formatKey(scoreTypeKey)})
                                  </span>
                                )}
                              </div>
                            </td>

                            <td className="border border-black px-3 py-3 align-top">
                              {factors.length > 0 ? (
                                <div>
                                  <ul className="list-disc list-inside space-y-1">
                                    {factors.map((factor, i) => (
                                      <li
                                        key={i}
                                        className="break-words text-gray-700 leading-relaxed"
                                      >
                                        {factor.trim()}
                                      </li>
                                    ))}
                                  </ul>
                                  {factorsKey && (
                                    <span className="text-[10px] text-gray-500 mt-2 block">
                                      ({formatKey(factorsKey)})
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="text-gray-500 italic">
                                  No factors available
                                </span>
                              )}
                            </td>

                            <td className="border border-black px-2 py-1 align-middle">
                              <div className="flex items-center justify-center">
                                <div className="bg-gradient-to-br from-green-400 to-green-500 rounded-xl border-2 border-green-700 shadow-lg px-2 py-2 min-w-[100px]">
                                  <div className="text-center">
                                    <div className="text-4xl font-bold text-white drop-shadow-md">
                                      {scoreValue}
                                    </div>
                                    <div className="text-[10px] font-semibold text-white uppercase tracking-wide mt-1">
                                      {scoreValueKey
                                        ? formatKey(scoreValueKey)
                                        : "Score"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </>
                );
              })()}
            </table>
          </div>

          {/* Account Information */}
          <div className="bg-blue-100 text-black p-2 mt-2 rounded-md text-sm font-semibold">
            Account Information:
          </div>

          {Array.isArray(modalData?.RESPONSES?.RESPONSE) &&
          modalData.RESPONSES.RESPONSE.length > 0 ? (
            modalData.RESPONSES.RESPONSE.map((item, index) => {
              const account = item["LOAN-DETAILS"];

              const buildPaymentHistory = (combinedHistory) => {
                if (!combinedHistory) return { months: [], history: {} };

                const months = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ];
                const yearsData = {};

                combinedHistory
                  .split("|")
                  .filter(Boolean)
                  .forEach((entry) => {
                    const [monthYear, status] = entry.split(",");
                    if (!monthYear || !status) return;

                    const [month, year] = monthYear.split(":");
                    const monthIndex = months.findIndex(
                      (m) => m.toLowerCase() === month.toLowerCase(),
                    );
                    if (monthIndex === -1 || !year) return;

                    if (!yearsData[year]) yearsData[year] = Array(12).fill("-");
                    yearsData[year][monthIndex] = status.trim();
                  });

                return { months, history: yearsData };
              };

              const { months, history } = buildPaymentHistory(
                account?.["COMBINED-PAYMENT-HISTORY"],
              );

              const getStatusColor = (value) => {
                if (value === "-") return "bg-white text-gray-400";
                if (value.includes("XXX")) return "bg-gray-200 text-gray-600";
                if (value.includes("000") || value.includes("STD"))
                  return "bg-white text-gray-700";
                return "bg-white text-gray-700";
              };

              const columns = splitIntoColumns(account, 3);

              return (
                <div
                  key={index}
                  className="mb-3 border border-gray-300 rounded bg-white shadow-sm"
                >
                  <div className="grid grid-cols-3 gap-x-3 gap-y-0 p-2 md:text-[10px] text-[9px] bg-blue-100">
                    {columns.map((col, colIdx) => (
                      <div key={colIdx} className="space-y-1">
                        {col
                          .filter(([key]) => key !== "COMBINED-PAYMENT-HISTORY")
                          .map(([key, value]) => {
                            let displayValue = value;

                            // If value is an object, convert it to a readable string
                            if (value && typeof value === "object") {
                              if (
                                key === "SECURITY-DETAILS" &&
                                value["SECURITY-DETAIL"]
                              ) {
                                const sd = value["SECURITY-DETAIL"];
                                displayValue = `Type: ${sd["SECURITY-TYPE"] || "N/A"}, Value: ${
                                  sd["SECURITY-VALUE"] || "0"
                                }`;
                              } else {
                                displayValue = JSON.stringify(value);
                              }
                            }

                            return (
                              <p key={key} className="font-semibold">
                                <span className="font-bold text-blue-800">
                                  {formatLabel(key)}:
                                </span>{" "}
                                {displayValue || "N/A"}
                              </p>
                            );
                          })}
                      </div>
                    ))}
                  </div>

                  <div className="overflow-x-auto border-t">
                    <table className="w-full text-center text-xs border-collapse">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border p-1"></th>
                          {months.map((m, i) => (
                            <th
                              key={i}
                              className="border p-1 text-blue-700 font-bold"
                            >
                              {m}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(history).length ? (
                          Object.keys(history)
                            .sort((a, b) => b - a)
                            .map((year) => (
                              <tr key={year}>
                                <td className="border p-1 font-bold bg-gray-50">
                                  {year}
                                </td>
                                {history[year].map((v, i) => (
                                  <td
                                    key={i}
                                    className={`border p-1 text-[9px] ${getStatusColor(
                                      v,
                                    )}`}
                                  >
                                    {v}
                                  </td>
                                ))}
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={13} className="p-3 text-gray-500">
                              No payment history available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="border p-4 text-center text-xs bg-white">
              No account details available.
            </div>
          )}

          {/* Legend / Static Codes */}
          <div className="w-full overflow-x-auto">
            <table className="w-full border border-gray-300 text-[10px] font-semibold">
              <thead className="bg-blue-200">
                <tr>
                  <th className="border px-1 py-0.5 text-left">Section</th>
                  <th className="border px-1 py-0.5 text-left">Code</th>
                  <th className="border px-1 py-0.5 text-left">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-1 py-0.5">Account Summary</td>
                  <td className="border px-1 py-0.5">
                    Number of Delinquent Accounts
                  </td>
                  <td className="border px-1 py-0.5">
                    Number of accounts defaulted within last 6 months
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Credit Grantor
                  </td>
                  <td className="border px-1 py-0.5">XXXX</td>
                  <td className="border px-1 py-0.5">
                    Credit grantor name undisclosed
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Account #
                  </td>
                  <td className="border px-1 py-0.5">XXXX</td>
                  <td className="border px-1 py-0.5">
                    Account number undisclosed
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">XXX</td>
                  <td className="border px-1 py-0.5">
                    Data not reported by institution
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">STD</td>
                  <td className="border px-1 py-0.5">Standard Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">SUB</td>
                  <td className="border px-1 py-0.5">Sub-Standard Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">DBT</td>
                  <td className="border px-1 py-0.5">Doubtful Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">LOS</td>
                  <td className="border px-1 py-0.5">Loss Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">SMA</td>
                  <td className="border px-1 py-0.5">
                    Special Mention Account
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">CRIF Highmark Score</td>
                  <td className="border px-1 py-0.5">PERFORM - Consumer</td>
                  <td className="border px-1 py-0.5">
                    Score based on credit history &amp; debt
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Account #
                  </td>
                  <td className="border px-1 py-0.5">CI-Ceased</td>
                  <td className="border px-1 py-0.5">
                    Institution ceased or membership terminated
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Summary Tables from ACCOUNTS-SUMMARY */}
          <div>
            <div className="bg-blue-300 text-black p-2 mt-1 text-sm font-semibold">
              Summary
            </div>

            {modalData?.["ACCOUNTS-SUMMARY"] &&
              Object.keys(modalData["ACCOUNTS-SUMMARY"]).map((sectionKey) => (
                <div key={sectionKey}>
                  <div className="bg-gray-100 px-2 py-1 text-xs font-bold">
                    {sectionKey.replace(/-/g, " ")}
                  </div>

                  <table className="w-full border text-[9px] mb-2">
                    <thead className="bg-gray-200">
                      <tr>
                        {Object.keys(
                          modalData["ACCOUNTS-SUMMARY"][sectionKey],
                        ).map((field) => (
                          <th key={field} className="border px-2 py-1">
                            {field.replace(/-/g, " ")}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      <tr>
                        {Object.entries(
                          modalData["ACCOUNTS-SUMMARY"][sectionKey],
                        ).map(([field, value]) => (
                          <td
                            key={field}
                            className={`border px-2 py-1 font-semibold ${
                              field.includes("OVERDUE")
                                ? "text-red-600"
                                : field.includes("AMOUNT") ||
                                    field.includes("BALANCE")
                                  ? "text-green-600"
                                  : "text-gray-700"
                            }`}
                          >
                            {field.includes("AMOUNT") ||
                            field.includes("BALANCE")
                              ? "₹"
                              : ""}
                            {value || "N/A"}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
          </div>

          {/* Inquiry History */}
          <div className="bg-blue-300 text-black p-2 mt-2 text-sm font-semibold">
            Inquiry History
          </div>

          {(() => {
            const inquiries = modalData?.["INQUIRY-HISTORY"]?.HISTORY;
            const list = Array.isArray(inquiries)
              ? inquiries
              : inquiries
                ? [inquiries]
                : [];

            if (list.length === 0)
              return (
                <div className="p-4 text-center text-xs">
                  No inquiry history
                </div>
              );

            const fields = Object.keys(list[0]);

            return (
              <table className="w-full border text-xs mb-2">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border px-2 py-1">#</th>
                    {fields.map((f) => (
                      <th key={f} className="border px-2 py-1">
                        {f.replace(/-/g, " ")}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {list.map((item, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="border px-2 py-1 font-bold">{i + 1}</td>
                      {fields.map((f) => (
                        <td
                          key={f}
                          className={`border px-2 py-1 ${
                            f.includes("AMOUNT")
                              ? "text-green-600 font-bold"
                              : f.includes("DATE")
                                ? "text-blue-600"
                                : "text-gray-700"
                          }`}
                        >
                          {f.includes("AMOUNT") ? "₹" : ""}
                          {item[f] || "N/A"}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}

          {/* END of Report footer */}
          <div className="mt-4">
            <h3 className="text-green-800 text-center font-bold">
              END of Report :{" "}
              {(() => {
                // Get latest name from NAME-VARIATIONS array (handles both array and single object)
                const nameVariations =
                  modalData?.["PERSONAL-INFO-VARIATION"]?.["NAME-VARIATIONS"]
                    ?.VARIATION;

                let latestName = "N/A";
                if (
                  Array.isArray(nameVariations) &&
                  nameVariations.length > 0
                ) {
                  // Take the LAST item (most recent)
                  latestName = nameVariations[nameVariations.length - 1]?.VALUE;
                } else if (nameVariations?.VALUE) {
                  // Single object case
                  latestName = nameVariations.VALUE;
                }

                // Fallback to REQUEST.NAME or error data
                return (
                  latestName ||
                  modalData?.REQUEST?.NAME ||
                  (modalDataError?.data?.first_name &&
                  modalDataError?.data?.last_name
                    ? `${modalDataError.data.first_name} ${modalDataError.data.last_name}`
                    : modalDataError?.data?.first_name ||
                      modalDataError?.first_name ||
                      modalDataError?.error?.first_name ||
                      "N/A")
                );
              })()}
            </h3>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <button
          className="bg-green-500 text-white p-1 rounded hover:bg-green-700"
          onClick={printDiv}
          disabled={isPrinting}
        >
          Print
        </button>
        <button
          className="bg-red-500 text-white p-1 rounded hover:bg-red-700"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CrifScoreReportModal;
